import { Routes } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';
import { LoginGuard } from './core/guard/login.guard';

export const routes: Routes = [
  // Public marketing pages – WebLayout, SSR Prerendered
  {
    path: '',
    loadComponent: () => import('./layouts/web-layout/web-layout').then(m => m.WebLayout),
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/web/home/home').then(m => m.Home),
        title: 'Home – Forever Web',
      },
    ],
  },

  // Auth pages – no layout, LoginGuard
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login').then(m => m.Login),
    data: { tab: 'signin' },
    canActivate: [LoginGuard],
    title: 'Login – Forever Memories',
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/auth/login/login').then(m => m.Login),
    canActivate: [LoginGuard],
    title: 'Register – Forever Memories',
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/auth/verify-email/verify-email').then(m => m.VerifyEmail),
    title: 'Verify Email – Forever Memories',
  },
  {
    path: 'create-family-space',
    loadComponent: () =>
      import('./pages/auth/create-family-space/create-family-space').then(m => m.CreateFamilySpace),
    canActivate: [AuthGuard],
    title: 'Create Family Space – Forever Memories',
  },
  {
    path: 'accept-invitation',
    loadComponent: () =>
      import('./pages/auth/accept-invitation/accept-invitation').then(m => m.AcceptInvitation),
    title: 'Accept Invitation – Forever Memories',
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forgot-password/forgot-password').then(m => m.ForgotPassword),
    title: 'Forgot Password – Forever Web',
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password').then(m => m.ResetPassword),
    title: 'Reset Password – Forever Web',
  },

  // Authenticated app pages – AppLayout, AuthGuard, Client SSR render
  {
    path: 'app',
    loadComponent: () => import('./layouts/app-layout/app-layout').then(m => m.AppLayout),
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'stories', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/app/dashboard/dashboard').then(m => m.Dashboard),
        title: 'Dashboard – Forever Memories',
      },
      {
        path: 'stories',
        loadComponent: () => import('./pages/app/stories/stories-list/stories-list').then(m => m.StoriesList),
        title: 'Stories – Forever Memories',
      },
      {
        path: 'stories/record',
        loadComponent: () => import('./pages/app/story-record/story-record').then(m => m.StoryRecord),
        title: 'Record a Story – Forever Memories',
      },
      {
        path: 'stories/record/review',
        loadComponent: () => import('./pages/app/story-record/story-review-video/story-review-video').then(m => m.StoryReviewVideo),
        title: 'Review Story - Forever Memories',
      },
      {
        path: 'stories/:id',
        loadComponent: () => import('./pages/app/stories/story-detail/story-detail').then(m => m.StoryDetail),
        title: 'Story – Forever Memories',
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/app/settings/settings').then(m => m.Settings),
        title: 'Settings & Privacy — Forever Memories',
      },
    ],
  },

  // Wildcard
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];
